export const NEW_EVENT_CREATED = "newEvent/created";
export const CLEAR_NEW_EVENT_CREATED = "newEvent/clear";
